import axios from 'axios'
import md5 from 'js-md5'

// 公用函数
let rFunc = {
    schemaId: '498',
    weChatId: 34443,//正式服务号戴尔官方企采中心市场活动
    tenantId: 444,
    api: {
        getGlobalUserId: '//api.dellemc-solution.com/anonymous/getId',
        getUserInfo: '//api.dellemc-solution.com/member/LookUp',
        getUserId: '//api.dellemc-solution.com/api/member/contacts/getbindinfo',
        userActionUrl: 'https://www.dellemc-solution.com/api/interaction/behavior', //自有用户行为接口
        signUpActionUrl: '//api.dellemc-solution.com/api/interaction/signup/create',
        getContactIdUrl: '//www.dellemc-solution.com/api/interaction/getContactIdByCookieId',

    },
    //获取cookie
    getCookie(name) {
        let arr;
        let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg)) {
            return decodeURIComponent(arr[2]);
        } else {
            return null;
        }
    },

    //写cookie
    setCookie(name, value, days) {
        let Days = days || 30;
        let exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toGMTString() + ';domain=.dellemc-solution.com;path=/';
    },

    //删除cookie
    delCookie(key) {
        rFunc.setCookie(key, '');
    },

    //是否登录
    isLogin() {
        let memberCookie = rFunc.getCookie('smarketMember_' + rFunc.schemaId);
        if (memberCookie) {
            return $.parseJSON(memberCookie);
        } else {
            gio('clearUserId');
            return false;
        }
    },

    //获取地址栏参数
    getUrlPara(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let r = window.location.search.substr(1).match(reg);
        if (r !== null) {
            return decodeURIComponent(r[2]);
        }
        return null;
    },

    // 获取匿名用户ID
    getGlobalUserId: function () {
        let cookieGlobalUserId = rFunc.getCookie('globalUserId');
        if (cookieGlobalUserId) {
            cookieGlobalUserId = cookieGlobalUserId.replace(/"/g, ""); //去除双引号
            return cookieGlobalUserId;
        }

        let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function (c) {
                let r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            }
        );
        uuid = uuid.replace(/-/g, "");
        rFunc.setCookie('globalUserId', uuid);
        return uuid;
    },

    isM: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),

};

// 获取utm字段
function getUtm() {
    // utm字段
    let utmObj = {
        utm_source: '',
        utm_medium: '',
        utm_campaign: '',
        utm_content: '',
        utm_term: ''
    };
    // 获取utm字段，任意一个字段有值，把所有的值都替换，都无值的时候，取现有cookie
    let utm_source = rFunc.getUrlPara('utm_source') || '';
    let utm_medium = rFunc.getUrlPara('utm_medium') || '';
    let utm_campaign = rFunc.getUrlPara('utm_campaign') || '';
    let utm_content = rFunc.getUrlPara('utm_content') || '';
    let utm_term = rFunc.getUrlPara('utm_term') || '';

    if (utm_source || utm_medium || utm_campaign || utm_content || utm_term) {
        utmObj = {
            utm_source: utm_source,
            utm_medium: utm_medium,
            utm_campaign: utm_campaign,
            utm_content: utm_content,
            utm_term: utm_term
        };
        rFunc.setCookie('utmObj', JSON.stringify(utmObj));
    } else {
        if (rFunc.getCookie('utmObj')) {
            utmObj = JSON.parse(rFunc.getCookie('utmObj'));
        }
    }

    utmObj.modulesources = rFunc.getUrlPara('linksourcemodule') || '';

    // 设置到全局
    window.common_utmObj = utmObj;
    return utmObj;
}

// 获取联系人ID
async function getContactId() {
    //
    let contactId = '';
    let contactCookieName = 'dell_contactId_' + md5(rFunc.getGlobalUserId());

    // 从cookie中获取联系人ID
    if (rFunc.getCookie(contactCookieName)) {
        contactId = rFunc.getCookie(contactCookieName);
        return contactId;
    } else {
        let res = await axios.get(rFunc.api.getContactIdUrl + '?cookieId=' + rFunc.getGlobalUserId());
        if (res.data.errCode === 0) {
            contactId = res.data.data.contactId;
            if (!contactId) return;
            rFunc.setCookie(contactCookieName, contactId, 5);
            return contactId;
        }
    }
}

// 获取注册用户ID
async function getUserId() {
    let userId = '';

    if (!rFunc.isLogin()) {
        return userId;
    }

    let info = {
        tenantId: rFunc.tenantId,
        sess: rFunc.isLogin().session || '',
    };

    let res = await axios.post(rFunc.api.getUserId, info)
    userId = res.data.body?.content?.loginId || '';
    return userId;
}

// 获取IP
async function getIp() {
    let _this = this;
    let res = await $.getScript('//s2-api.smarket.net.cn/cityjson');
    return returnCitySN.cip;
}

// 获取客户端信息
function getClientInfo() {
    let ua, liulanqi, banben, os, equipment, isEdge, isSafari, isChrome, isFirefox, isOpera, isIE, isBrowser, isAndroid,
        isWe, isIPhones, isIPad, isVersion, isWeChat;
    ua = navigator.userAgent;
    liulanqi = '';
    banben = '';
    os = '';
    equipment = '';
    isEdge = ua.match(/(Edge)\/([\d.]+)/i);
    isSafari = ua.match(/Version\/([\d.]+)\s+?(Safari)/i);
    isChrome = ua.match(/(Chrome)\/([\d.]+)/i);
    isFirefox = ua.match(/(Firefox)\/([\d.]+)/i);
    isOpera = ua.match(/(OPR|OPERA).+?([\d.]+)/i);
    isIE = ua.indexOf('Trident') > -1 || ua.toLocaleLowerCase().indexOf('msie') > -1;
    isBrowser = ua.match(/(\w+Browser)[^\d]+?([\d.]+)/i) || ua.match(/\d\s+?([^\d]+)([\d.]+)$/i);
    isAndroid = ua.match(/(Android[\s\d.]+);.+?([^;]+)Build/i);
    isWe = ua.match(/MicroMessenger.+?([\d.]+)/i);
    isIPhones = ua.match(/CPU([\s\w\d_]+)like/i);
    isIPad = ua.match(/iPad/i) ? 'iPad' : 'iPhone';
    isVersion = ua.match(/Version\/([\d.]+)/i);
    isWeChat = isWe;

    //如果是移动端
    if (!!ua.match(/AppleWebKit.*Mobile.*/)) {
        if (isWe) {
            liulanqi = '微信';
            banben = isWe[1];
        } else {
            if (isBrowser) {
                liulanqi = isBrowser[1];
                banben = isBrowser[2];
                if (liulanqi.indexOf('Browser') === -1 && isVersion) {
                    banben = isVersion[1];
                }
            } else {
                liulanqi = '手持设备浏览器';
                banben = '未知';
            }
        }
        if (isAndroid) {
            os = isAndroid[1];
            equipment = isAndroid[2];
        } else {
            if (isIPhones) {
                os = isIPhones[1];
            } else {
                os = isIPad;
            }
            equipment = isIPad;
        }
    } else {
        if (isSafari) {
            liulanqi = isSafari[2];
            banben = isSafari[1];
        }
        if (isChrome) {
            liulanqi = isChrome[1];
            banben = isChrome[2];
        }
        if (isFirefox) {
            liulanqi = isFirefox[1];
            banben = isFirefox[2];
        }
        if (isEdge) {
            liulanqi = isEdge[1];
            banben = isEdge[2];
        }
        if (isOpera) {
            liulanqi = 'OPERA';
            banben = isOpera[2];
        }

        if (isIE) {
            liulanqi = 'IE';
            let isIEV01 = ua.match(/(MSIE).+?(\d+)/i);
            let isIEV02 = ua.match(/(rv).+?(\d+)/i);
            if (isIEV01) {
                banben = isIEV01[2];
            }
            if (isIEV02) {
                banben = isIEV02[2];
            }
        }
        os = ua.match(/windows/i) ? 'Windows' : 'Mac OS';
        equipment = '电脑端';
    }

    return {
        browser: {
            version: banben,
            name: liulanqi,
        },
        browseInfo: {
            userAgent: ua,
            browser: liulanqi,
            version: banben,
            os: os,
            equipment: equipment,
            resolution: window.screen.width + 'X' + window.screen.height,
            referenceUrl: document.referrer || '',
            referenceTitle: '',
        },
        os: {
            name: os,
        },
        screen: {
            width: window.screen.width,
            height: window.screen.height,
            resolution: window.screen.width + ' * ' + window.screen.height,
        },
    }
}

// 提交用户行为
async function submitUserBehavior(options) {
    let res = await axios.post(rFunc.api.userActionUrl, options)
    console.log('用户行为数据', res);
}

// 用户事件记录
function userRecord() {

}


// 参数
let options = {
    contactId: '',
    userId: '',
    cookieId: '',

    module: '',
    category1: '',
    category2: '',
    category3: '',
    title: '',
    url: location.href,

    tagId: '',
    tag: '',
    mediaSources: rFunc.getCookie('mediaSource') || '',

    equipment: '',
    browser: '',
    platform: '',
    ip: '',

    linkSource: document.referrer,

    behaviorResult: '浏览成功',
    behaviorType: '浏览网页',

    utmParam: '',
    client: rFunc.isM ? '手机端' : '电脑端',
    entrance: '',
    sid: rFunc.getCookie('sid') || '',
    ifCookie: rFunc.getCookie('ifCookie') || '是',

    utmSource: '',
    utmMedium: '',
    utmCampaign: '',
    utmContent: '',
    utmTerm: '',

    linkSourceModule: rFunc.getCookie('linkSourceModule_pvar') || '', //页面来源栏目模块（行为数据)
};

// 页面变量设置
async function pageSet(pageInfo) {
    // 设置匿名ID
    options.cookieId = rFunc.getGlobalUserId();

    // 合并浏览器信息
    let browseInfo = getClientInfo().browseInfo;

    // 获取IP
    options.ip = await getIp();

    // 获取UTM
    let utm = getUtm();

    // 获取联系人ID
    options.contactId = await getContactId();

    // 获取注册用户ID
    options.userId = await getUserId();

    // 合并
    Object.assign(options, {
        module: pageInfo.module,
        category1: pageInfo.category1,
        category2: pageInfo.category2,
        category3: pageInfo.category3,
        title: pageInfo.title,

        equipment: browseInfo.equipment,
        browser: browseInfo.browser,
        platform: browseInfo.os,

        utmSource: utm.utm_source,
        utmMedium: utm.utm_medium,
        utmCampaign: utm.utm_campaign,
        utmContent: utm.utm_content,
        utmTerm: utm.utm_term,
    });
    if (rFunc.isLogin()) {
        options.session = rFunc.isLogin().session;
        options.OCSESSID = rFunc.getCookie('OCSESSID');
    }

    console.log('用户行为数据', options);

    await submitUserBehavior(options)
}

export default {
    pageSet,
    userRecord
}
